// @flow
import React, { Component } from 'react';
import { loadScripts } from '../../../../utils/scripts';

type Props = {
    content: Object,
    options: {
        scripts: array,
        params: Object,
    },
};

const scripts = [
    {
        src: '//imasdk.googleapis.com/js/sdkloader/ima3.js',
        id: 'laola-sdk',
        type: 'script',
    },
    {
        src: '//cdn.laola1.tv/player/dist/latest/laola1player.min.js',
        id: 'laola-player',
        type: 'script',
    },
    {
        href: '//cdn.laola1.tv/player/dist/latest/laola1player.min.css',
        id: 'laola-styles',
        type: 'stylesheet',
    },
];

export default class Laola extends Component<Props> {
    createVideoPlayer = (video_id, partner_id) => {
        const customParam =
            this.props.options && this.props.options.params
                ? this.props.options.params
                : {};

        return new L1VideoPlayer({
            id: video_id,
            videoid: video_id,
            v5ident: '',
            partnerid: partner_id,
            portalid: 'at',
            language: 'de',
            share: true,
            adPause: 'false',
            showTitle: false,
            volume: 100,
            showTimer: true,
            autoplay: false,
            configUrl: '//www.laola1.tv/service/player/videoConfig.php',
            ...customParam,
        });
    };

    componentDidMount() {
        if (this.props.content === '') return;

        const { video_id, partner_id } = this.props.content;
        const customScripts = this.props.options && this.props.options.scripts;

        if (customScripts)
            loadScripts(customScripts)
                .then(() => {
                    if (typeof L1VideoPlayer !== 'undefined')
                        this.createVideoPlayer(video_id, partner_id);
                })
                .catch(error => {
                    console.error('Could not load laola scripts: ', error);
                });
        else
            loadScripts(scripts)
                .then(() => {
                    if (typeof L1VideoPlayer !== 'undefined')
                        this.createVideoPlayer(video_id, partner_id);
                })
                .catch(error => {
                    console.error('Could not load laola scripts: ', error);
                });
    }

    componentWillUnmount() {
        scripts.forEach(s => {
            const e = document.getElementById(s.id);
            if (e) {
                e.outerHTML = '';
            }
        });
    }

    render() {
        const { video_id } = this.props.content;

        return <div id={video_id} />;
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Ovp/Laola.js